

// import React, { useState, useEffect, useCallback } from "react";
// import PropTypes from "prop-types";
// import "./Carousel.css";

// const Carousel = ({ data, title, onSelect, autoPlay, autoPlayTime, className }) => {
//   const [currentIndex, setCurrentIndex] = useState(0);

//   const handleNext = useCallback(() => {
//     if (data.length > 0) {
//       setCurrentIndex((prevIndex) => (prevIndex + 3) % data.length);
//     }
//   }, [data]);

//   const handlePrev = () => {
//     if (data.length > 0) {
//       setCurrentIndex((prevIndex) => (prevIndex - 3 + data.length) % data.length);
//     }
//   };

//   const goToSlide = (index) => setCurrentIndex(index);

//   const handleItemClick = (index) => {
//     if (onSelect && typeof onSelect === "function") {
//       onSelect(data[index]);
//     }
//   };

//   useEffect(() => {
//     if (autoPlay && data.length > 1) {
//       const interval = setInterval(handleNext, autoPlayTime);
//       return () => clearInterval(interval);
//     }
//   }, [autoPlay, autoPlayTime, handleNext, data.length]);

//   const getVisibleItems = () => {
//     if (data.length === 0) return [];
//     const items = Array.from({ length: 3 }, (_, i) => data[(currentIndex + i) % data.length]);
//     return items;
//   };

//   if (!data || data.length === 0) {
//     return <div className="carousel"><p>No items available</p></div>;
//   }

//   return (
//     <div className={`carousel ${className || ''}`}>
//       <h3>{title}</h3>
//       <div className="carousel-container">
//         <button 
//             type="button"
//             onClick={(e) => {
//             e.stopPropagation();
//             handlePrev();
//           }}
//           className="carousel-button prev"
//           aria-label="Previous Slide"
//         >
//           &#10094;
//         </button>
//         <div className="carousel-items">
//           {getVisibleItems().map((item, index) => (
//             <div
//               key={item?.id || index}
//               className="carousel-item"
//               onClick={() => handleItemClick((currentIndex + index) % data.length)}
//               role="button"
//               tabIndex={0}
//               onKeyPress={(e) => { if (e.key === 'Enter') handleItemClick((currentIndex + index) % data.length); }}
//             >
//               <h4>{item?.label || "No Label Available"}</h4>
//             </div>
//           ))}
//         </div>
//         <button 
//             type="button"  // ← Add this
//             onClick={(e) => {
//             e.stopPropagation();  // ← Prevent event bubbling
//             handleNext();
//           }}
//           className="carousel-button next"
//           aria-label="Next Slide"
//         >
//           &#10095;
//         </button>
//       </div>
//       <div className="carousel-indicators">
//         {data.map((item, index) => (
//           <span
//             key={item?.id || index}
//             className={`indicator ${index === currentIndex ? "active" : ""}`}
//             onClick={() => goToSlide(index)}
//             role="button"
//             tabIndex={0}
//             onKeyPress={(e) => { if (e.key === 'Enter') goToSlide(index); }}
//             aria-label={`Go to slide ${index + 1}`}
//           ></span>
//         ))}
//       </div>
//     </div>
//   );
// };

// Carousel.propTypes = {
//   data: PropTypes.arrayOf(
//     PropTypes.shape({
//       id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
//       label: PropTypes.string.isRequired,
//       positivePrompt: PropTypes.string,
//       negativePrompt: PropTypes.string,
//     })
//   ).isRequired,
//   title: PropTypes.string.isRequired,
//   onSelect: PropTypes.func,
//   autoPlay: PropTypes.bool,
//   autoPlayTime: PropTypes.number,
//   className: PropTypes.string,
// };

// Carousel.defaultProps = {
//   data: [],
//   autoPlay: false,
//   autoPlayTime: 3000,
// };

// export default Carousel;



// Carousel.js
import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import "./Carousel.css";

const Carousel = ({ data, title, onSelect, autoPlay, autoPlayTime, className }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedItemId, setSelectedItemId] = useState(null);

  const handleNext = useCallback(() => {
    if (data.length > 0) {
      setCurrentIndex((prevIndex) => (prevIndex + 3) % data.length);
    }
  }, [data]);

  const handlePrev = () => {
    if (data.length > 0) {
      setCurrentIndex((prevIndex) => (prevIndex - 3 + data.length) % data.length);
    }
  };

  const goToSlide = (index) => setCurrentIndex(index);

  const handleItemClick = (index) => {
    const clickedItem = data[(currentIndex + index) % data.length];
    setSelectedItemId(clickedItem.id); // Set the selected item ID
    
    if (onSelect && typeof onSelect === "function") {
      onSelect(clickedItem);
    }
  };

  // Reset selection when data changes
  useEffect(() => {
    setSelectedItemId(null);
  }, [data]);

  const getVisibleItems = () => {
    if (data.length === 0) return [];
    return Array.from({ length: 3 }, (_, i) => data[(currentIndex + i) % data.length]);
  };

  if (!data || data.length === 0) {
    return <div className="carousel"><p>No items available</p></div>;
  }

  return (
    <div className={`carousel ${className || ''}`}>
      <h3>{title}</h3>
      <div className="carousel-container">
        <button 
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            handlePrev();
          }}
          className="carousel-button prev"
          aria-label="Previous Slide"
        >
          &#10094;
        </button>
        <div className="carousel-items">
          {getVisibleItems().map((item, index) => (
            <div
              key={item?.id || index}
              className={`carousel-item ${selectedItemId === item?.id ? "selected" : ""}`}
              onClick={() => handleItemClick(index)}
              role="button"
              tabIndex={0}
              onKeyPress={(e) => { if (e.key === 'Enter') handleItemClick(index); }}
            >
              {item?.image && (
                <img 
                  src={item.image} 
                  alt={item.label || "Carousel item"} 
                  onError={(e) => {
                    e.target.onerror = null; 
                    // e.target.src = "placeholder-image-path";
                  }}
                />
              )}
              <h4>{item?.label || "No Label Available"}</h4>
            </div>
          ))}
        </div>
        <button 
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            handleNext();
          }}
          className="carousel-button next"
          aria-label="Next Slide"
        >
          &#10095;
        </button>
      </div>
      <div className="carousel-indicators">
        {data.map((item, index) => (
          <span
            key={item?.id || index}
            className={`indicator ${index === currentIndex ? "active" : ""}`}
            onClick={() => goToSlide(index)}
            role="button"
            tabIndex={0}
            onKeyPress={(e) => { if (e.key === 'Enter') goToSlide(index); }}
            aria-label={`Go to slide ${index + 1}`}
          ></span>
        ))}
      </div>
    </div>
  );
};

Carousel.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      label: PropTypes.string.isRequired,
      image: PropTypes.string,
      positivePrompt: PropTypes.string,
      negativePrompt: PropTypes.string,
    })
  ).isRequired,
  title: PropTypes.string.isRequired,
  onSelect: PropTypes.func,
  autoPlay: PropTypes.bool,
  autoPlayTime: PropTypes.number,
  className: PropTypes.string,
};

Carousel.defaultProps = {
  data: [],
  autoPlay: false,
  autoPlayTime: 3000,
};

export default Carousel;